import React from "react";

interface IScrollToTopComponentProps {}

export const ScrollToTopComponent: React.FC<IScrollToTopComponentProps> = (
    props: IScrollToTopComponentProps
) => {
    return ( 
        <a
            href="/#"
            id="scroll-top"
            className="scroll-top d-flex align-items-center justify-content-center gradient-bg">
            <i className="bi bi-arrow-up-short"></i>
        </a>
    );
};
